
import React from 'react'

import './VerticalScrollBar.scss'

interface Props {
  height: number
  top: number
  onScroll: (top: number) => void
}

const VerticalScrollBar = (props: Props) => {

  const { height, top, onScroll } = props

  // it will be a scroll bar to scroll the image
  return (
    <div className="scroll-bar-container"
      style={{
        height: `${height}px`,
        width: 36
      }}
    >
      {/* <div className="scroll-bar"
        draggable={true}
        onDragStart={(e: any) => e.preventDefault()}
        onDrag={(e: any) => onScroll(e.clientY)}
      /> */}

      <input
        type="range"
        min="0"
        max="100"
        value={top}
        onChange={(e: any) => onScroll(e.target.value)}
        className="scroll-bar"
      />
    </div>
  )
}

export default VerticalScrollBar
